export default "__VITE_ASSET__BC1e4t47__"